<template>
  <div class="anagrafica">
    <navbar></navbar>
    <b-container style="height: 80vh;">
      <b-row style="height: 80%;">
          <b-col id="list-user">
            <h2>LISTA ANAGRAFICA CARICATA</h2>
            <scrolly id="list">
              <scrolly-viewport>
                <b-list-group v-for="(value, index) in anagrafica" :key="index">
                  <b-list-group-item v-if="index%2 == 0" v-on:click="modalAnagraficaOpen(value)">{{value.ragione}}</b-list-group-item>
                  <b-list-group-item variant="secondary" v-else v-on:click="modalAnagraficaOpen(value)">{{value.ragione}}</b-list-group-item>
                </b-list-group>
              </scrolly-viewport>
              <scrolly-bar axis="y"></scrolly-bar>
              <scrolly-bar axis="x"></scrolly-bar>
            </scrolly>
          </b-col>
          <b-col id="add-user">
            <h2>CARICA ANAGRAFICA</h2>
            <br>
            <b-form v-on:submit.prevent="addAnagrafica">
              <b-input-group prepend="Anagrafica">
                <b-form-file v-model="file" placeholder="Seleziona il file anagrafica..." :disabled="stato.punti != -1"></b-form-file>
              </b-input-group>
              <br>
              <b-button type="submit" variant="success" :disabled="stato.punti != -1">
                <div class="spinner">
                  <p v-if="stato.punti != -1">Caricamento in corso</p>
                  <p v-else>Carica anagrafica</p>
                  <div class="bounce1" v-if="stato.punti != -1"></div>
                  <div class="bounce2" v-if="stato.punti != -1"></div>
                  <div class="bounce3" v-if="stato.punti != -1"></div>
                  <b-badge variant="light" v-if="stato.punti != -1" style="margin-left: 8px">{{stato.comuni}}/{{tot_tuple}}</b-badge>
                  <b-badge variant="light" v-if="stato.punti != -1" style="margin-left: 8px">{{stato.anagrafica}}/{{tot_tuple}}</b-badge>
                  <b-badge variant="light" v-if="stato.punti != -1" style="margin-left: 8px">{{stato.punti}}/{{tot_tuple}}</b-badge>
                </div>
              </b-button>
            </b-form>
            <br>
            <scrolly v-if="error_pipe.length > 0" :style="{height: '300px'}">
              <scrolly-viewport>
                <b-list-group v-for="(value, index) in error_pipe" :key="index">
                  <b-list-group-item :variant="value.error_type">{{value.msg}}</b-list-group-item>
                </b-list-group>
              </scrolly-viewport>
              <scrolly-bar axis="y"></scrolly-bar>
              <scrolly-bar axis="x"></scrolly-bar>
            </scrolly>
          </b-col>
      </b-row>
  </b-container>
  <b-modal v-model="modal.anagrafica" title="Dettagli anagrafica">
    <b-form v-on:submit.prevent="addAnagrafica">
      <b-input-group prepend="Cod. contabilità">
        <b-form-input v-model="modaldata.cod_contab" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="Ragione">
        <b-form-input v-model="modaldata.ragione" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="P. IVA">
        <b-form-input v-model="modaldata.p_iva" disabled></b-form-input>
      </b-input-group>
      <br>
      <b-input-group prepend="C.F.">
        <b-form-input v-model="modaldata.cf" disabled></b-form-input>
      </b-input-group>
      <br>
    </b-form>

    <div slot="modal-footer" class="w-100" v-if="!modal.anagraficadelete">
      <b-container>
        <b-row>
          <b-col><b-button variant="danger" size="sm" v-on:click="modal.anagraficadelete = true">Elimina</b-button></b-col>
          <b-col></b-col>
          <b-col><b-button variant="secondary" style="float: right;" v-on:click="modal.anagrafica = false">Chiudi</b-button></b-col>
        </b-row>
      </b-container>
    </div>
    <div slot="modal-footer" class="w-100" v-else>
      <p style="float: left;">Si sta eliminando questo elemento, proseguire?</p>
      <b-button variant="secondary" style="float: right; margin-left: 10px;" v-on:click="modal.anagraficadelete = false">No</b-button>
      <b-button variant="danger" style="float: right;" v-on:click="deleteAnagrafica(modaldata.id)">Si</b-button>
    </div>
  </b-modal>
  </div>
  
</template>

<script>
import Vue from 'vue'
import navbar from '@/components/navbar.vue'
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly'

export default {
  name: 'anagrafica',
  components: {
    navbar,
    Scrolly,
    ScrollyViewport,
    ScrollyBar
  },
  data() {
    return {
      anagrafica: [],
      territori: [],
      file: null,
      modal: {
        anagrafica: false,
        anagraficadelete: false
      },
      modaldata: {},
      stato: {
        comuni: -1,
        anagrafica: -1,
        punti: -1
      },
      tot_tuple: 0,
      error_pipe: []
    }
  },
  created: function(){
        this.updateAnagraficaList()
        this.getUploadStato()
  },
  methods: {
    addAnagrafica() {
      if(this.file != null){
        this.error_pipe = []
        this.stato.comuni = 0
        this.stato.anagrafica = 0
        this.stato.punti = 0
        //this.$Progress.start()
        let formData = new FormData();
        formData.append('f1', this.file);
        Vue.http.post(this.$hostlink+'anagrafica/upload', formData, {credentials : true, headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
          if(response.body.success){
            this.tot_tuple = response.body.tot_tuple
            this.getUploadStato()
            //this.$Progress.finish()
            Vue.notify({
              group: 'global',
              title: 'Operazione eseguita',
              text: 'File caricato con successo!',
              type: 'success'
            })
            Vue.notify({
              group: 'global',
              title: 'Elaborazione in corso...',
              text: 'Il server sta elaborando '+response.body.tot_tuple+' elementi!',
              type: 'info'
            })
          }
        }, response => {
          Vue.notify({
            group: 'global',
            title: 'Errore di comunicazione',
            text: 'Errore di comunicazione con i server!',
            type: 'error'
          })
          //this.$Progress.fail()
        })
      }else{
        Vue.notify({
          group: 'global',
          title: 'Nessun file selezionato',
          text: 'Assicurati di aver selezionato un file!',
          type: 'error'
        })
      }
    },
    updateAnagraficaList(){
      Vue.http.post(this.$hostlink+'anagrafica/list', {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.anagrafica = response.body.data
        }
      }, response => {
          // error callback
      })
    },
    deleteAnagrafica(id){
      Vue.http.post(this.$hostlink+'anagrafica/delete', {id: id}, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione eseguita',
            text: 'Anagrafica eliminato con successo!',
            type: 'success'
          })
        }else
          Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante l\'eliminazione dell\'elemento. Verificare se non è stato precedentemente eliminato!',
            type: 'error'
          })
        this.modal.anagrafica = false
        this.updateAnagraficaList()
      }, response => {
        Vue.notify({
          group: 'global',
          title: 'Errore!',
          text: 'Errore durante la comunicazione con il server!',
          type: 'error'
        })
      })
    },
    modalAnagraficaOpen(anagrafica){
      this.modaldata = anagrafica
      this.modal.anagraficadelete = false
      this.modal.anagrafica = true
    },
    getUploadStato(){
       Vue.http.post(this.$hostlink+'anagrafica/upload/get', {}, {credentials : true}).then(response => {
         if(response.body.success){
           if(this.tot_tuple == 0){
             this.tot_tuple = response.body.tot_tuple
           }
           this.stato = response.body.tot_stored
           if(!response.body.upload_end){
             setTimeout(this.getUploadStato, 500);
           }else{
            this.stato.punti = -1
            this.tot_tuple = 0
            if(response.body.tot_stored.comuni != -1 && response.body.tot_stored.anagrafica != -1 && response.body.tot_stored.punti != -1)
              Vue.notify({
                group: 'global',
                title: 'Operazione eseguita',
                text: 'Anagrafica caricata con successo!',
                type: 'success'
              })
            this.updateAnagraficaList()
            if(response.body.error){
              Vue.notify({
                group: 'global',
                title: 'Ci sono alcuni errori',
                text: 'Durante l\'elaborazione del file ci sono stati degli errori!',
                type: 'warn'
              })
              Vue.http.post(this.$hostlink+'anagrafica/upload/error', {}, {credentials : true}).then(resp => {
                console.log(resp.body.error_info)
                this.error_pipe = resp.body.error_info
              })
            }
          }
         }else{
           Vue.notify({
            group: 'global',
            title: 'Errore!',
            text: 'Errore durante la comunicazione con il server!',
            type: 'error'
          })
         }
       })
    }
  }
}
</script>

<style>
#list-user{
  margin-top: 10%;
}

#list{
  height: 100%;
}

#add-user{
  margin-top: 10%;
  height: 100%;
}

/*CSS loader animated*/
.spinner {
  /*margin: 100px auto 0;*/
  /*width: 70px;*/
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;
  background-color: white;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner > p {
  margin: 0;
  float: left;
  margin-right: 8px;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
